module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }), _c('a', {
    attrs: {
      "id": "page41"
    }
  }), _c('span', {
    staticClass: "big1"
  }, [_vm._v("2"), _c('br'), _vm._v("The Vision of Virtuous Women")]), _c('br'), _vm._v("The Twenty Pearls of Alpha Kappa Alpha Sorority"), _c('br'), _c('em', [_c('span', {
    staticClass: "normal"
  }, [_vm._v("Stephanie Y. Evans")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("This chapter traces the lives of the founders, original members, and incorporators of the Alpha Kappa Alpha Sorority: the twenty “Pearls.” The sorority brought together like-minded women from disparate paths to celebrate scholarship and provide dedicated “service to all mankind.” On January 15, 1908, nine women, led by Ethel Hedgeman Lyle and advised by Ethel Esther Maria Tremain Robinson and Elizabeth Appo Cook at Howard University, brought forth an organization dedicated in sisterhood to live and work “by culture and by merit.” The motto, translated into Greek, became "), _c('em', [_vm._v("Askosis Kai Axiosis,")]), _vm._v(" and the letters AKA, the ivy leaf, and pink for femininity and green for everlasting life became the signs of the first black women’s collegiate sisterhood."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn1",
      "id": "c02_fn1a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Alpha chapter expanded by inviting seven sophomore honor students to join the organization in late February 1908. The first initiation of new members took place in February 1909, and on January 29, 1913, six members banded together to incorporate and expand Alpha Kappa Alpha Sorority, making it the first national, incorporated Greek-letter organization for black college women."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn2",
      "id": "c02_fn2a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("The First Nine")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("ETHEL OCTAVIA HEDGEMAN LYLE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ethel Octavia Hedgeman (1887–1950) was born in St. Louis and graduated from Sumner High School there; she received that school’s first scholarship to attend Howard University. Although Hedgeman made history as a founder of the first black sorority, she also had a clear sense of history from her distinguished family heritage. Her paternal grandfather, born in 1824, was an African Methodist Episcopal minister who helped establish churches from St. Paul, Minnesota, to "), _c('a', {
    attrs: {
      "id": "page42"
    }
  }), _vm._v("Denver, Colorado. Her maternal grandfather escaped enslavement to participate as a Union solider in the Civil War and became one of the founding members of Lincoln University in Missouri. Her mother, Maria Hubbard Hedgeman, was a certified teacher, but she stayed home to raise Ethel and her two sisters, Iota and Thelma. Ethel’s father, Albert Hedgeman, born in 1858, was a respected community builder who worked for the YMCA."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn3",
      "id": "c02_fn3a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ethel entered Howard in 1904 but had to withdraw after the first year due to illness. At Howard, she was active in the university choir, Christian Endeavor, drama productions, and the YWCA."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn4",
      "id": "c02_fn4a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("4")])]), _vm._v(" She was described as “a lively, charming, bubbling young woman, full of life and laughter, although somewhat delicate in health.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn5",
      "id": "c02_fn5a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ethel’s close friend George Lyle was a member of Alpha Phi Alpha Fraternity, and she was encouraged to develop a sorority by Ethel Robinson, a native of Providence, Rhode Island, who had graduated from Brown University and participated in sorority activities there. With an innovative spirit, Ethel convened eight Howard coeds and established the first sorority for African American women. In addition to being the originator, she worked with Margaret Flagg and Lavinia Norman to finalize the organization’s constitution, which had been drafted by Lucy Diggs Slowe, and she designed the ivy leaf inscribed with “AKA” as their symbol. Lucy Slowe (the only senior in the new organization) became the first president; Hedgeman was elected president in the fall of 1908 and was succeeded by Lavinia Norman."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn6",
      "id": "c02_fn6a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After graduating in 1909 with a bachelor’s degree in English and liberal arts, Hedgeman moved to Enfala, Oklahoma, where she taught music and English and stayed until 1910. She is recognized as the first college-trained black woman to teach in a normal school in Oklahoma and the first to receive a Life Teacher’s Certificate from the Department of Education there. For the 1910–1911 school year, she taught at a public school in Centralia, Illinois."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn7",
      "id": "c02_fn7a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On celebrating the twentieth anniversary of the sorority’s formation, Margaret Flagg Holmes recalled Hedgeman’s personality, saying that Ethel “was a jolly, fun-loving loveable girl, whose outstanding charm was her gurgling, bubbling laughter. School work (for she was a brilliant student) and George Lyle vied with each other for Ethel’s affections.” Hedgeman’s commitment to scholarship and community service continued to flourish, as did her love for Lyle. On June 21, 1911, Ethel Hedgeman married George Lyle in New York City. They moved immediately to Philadelphia, where George became a high school principal. They had one son, George Lyle Jr., who eventually married and had two children. When her daughter-in-law passed away, Ethel ensured that her "), _c('a', {
    attrs: {
      "id": "page43"
    }
  }), _vm._v("two granddaughters, Murieal Jean and Andrea Joan, were dearly cared for. In addition to supporting her family, she enjoyed reading, working crossword puzzles, and playing bridge."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn8",
      "id": "c02_fn8a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While taking good care of family matters, Mrs. Lyle was also engaged in community affairs in Philadelphia. She founded the Mother’s Club of the City, was a charter member of the West Philadelphia League of Women Voters, and was a member of the Republican Women’s Committee of Ward 40. In 1937, she was appointed chairperson of the Mayor’s Committee of One Hundred Women and charged with planning the sesquicentennial of the adoption of the Constitution. While her civic and social activities are widely known, it is lesser known that Ethel Hedgeman Lyle also attended graduate school at both the University of Pennsylvania and Temple University."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn9",
      "id": "c02_fn9a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like most women who attended college in the early twentieth century, Lyle was a dedicated teacher. She taught English in the public schools of Philadelphia from 1921 to 1948, when she retired. With all her family and community responsibilities, she remained ever faithful to her sorority and supported many chapters, in addition to its growth on a national level. She was a charter member of the Mu Chapter (established in 1922 in Philadelphia); in 1923, she was elected Supreme Tamiouchos (national treasurer), a position she held until 1946. She also was a founder and Basileus of the Omega Omega Graduate Chapter (established in 1926 in Philadelphia)."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn10",
      "id": "c02_fn10a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ethel Hedgeman Lyle was honored many times through the years. She was named Honorary Supreme Basileus (national president) by Alpha Kappa Alpha in 1926 and held that title until her passing on November 28, 1950. No other member has been awarded this honor. Her funeral was held at Mount Pasgah African Methodist Episcopal Church on December 2, and she was buried in the city of Philadelphia. The Ethel Hedgeman Lyle Endowment Fund was named in her honor, and at the 1958 Golden Anniversary Boulé (the national convention) in Washington, D.C., her granddaughters were awarded a $1,000 scholarship to attend college and follow in their grandmother’s footsteps."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn11",
      "id": "c02_fn11a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("11")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("BEULAH ELIZABETH BURKE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beulah Burke (1885–1975) was born in Hertford, North Carolina. She and her sister Lillie attended preparatory school in North Carolina, and Beulah entered Howard University at age fifteen in 1900. She graduated with a bachelor’s degree in Latin in 1908. She also studied Greek, German, English, political science, chemistry, and physics. She taught for one year in Georgia and "), _c('a', {
    attrs: {
      "id": "page44"
    }
  }), _vm._v("then in Kansas City, Kansas. She earned a master’s degree in home economics from Columbia University and did further graduate study at the University of Chicago."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn12",
      "id": "c02_fn12a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beulah was a vital force in the incorporation process and an advocate for the development of Alpha Kappa Alpha as a national organization. She used her proficiency in Greek to propose the name Alpha Kappa Alpha, which means “by merit and by culture.” She also suggested that the sorority’s colors be apple green and salmon pink. After incorporation, she chartered the first chapters at the University of Chicago (Beta Chapter, 1913), University of Illinois (Gamma Chapter, 1913), and University of Kansas (1914) and established graduate chapters in both Kansas City, Missouri (Beta Omega, 1920), and Kansas City, Kansas (Mu Omega, 1922). She was Basileus of both graduate chapters. She was involved as hostess Basileus at the 1922 Kansas City Boulé and was the Second Supreme Anti-Basileus during 1923. She served as midwestern regional director in 1925 and participated in many other local and national activities."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn13",
      "id": "c02_fn13a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beulah taught at Delaware State College in Dover and then in Atlantic City, New Jersey, before returning to Washington, D.C., and joining the Xi Omega Chapter. In 1968, she attended the Sixtieth Founders’ Day Celebration, where she, Norma Boyd, and Lavinia Norman were honored guests. In Washington, Burke was a member of the NAACP, YWCA, National Education Association, and Worker’s Organization, which advocated for black women’s employment opportunities. She was known for her sewing and tailoring and held a position at Howard University. Beulah passed away, after a long illness, on April 28, 1975, in Washington, and she rests eternal in Lincoln Cemetery. She was eighty-nine years old and a member of Alpha Kappa Alpha for sixty-seven years."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn14",
      "id": "c02_fn14a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("LILLIE BURKE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like her sister Beulah, Lillie Burke (?–1949) was born and raised in Hertford, North Carolina. Lillie entered the preparatory department of Howard University in 1900 and earned a bachelor’s degree in English in 1908. Margaret Flagg Holmes described both sisters as “tall, fair, and good looking,” with Lillie being “oh so serious” and, like her sister, proficient in Greek. Lillie attended the University of Pennsylvania for graduate study. She then began her teaching career in Downington, Pennsylvania, where she headed the Academic Department of the Downing Institute. In 1911, she returned to North Carolina and taught "), _c('a', {
    attrs: {
      "id": "page45"
    }
  }), _vm._v("English at the State Normal School in Fayetteville, but stayed for only one year. Lillie moved back to Washington, D.C., in 1912; Beulah would join her there in the 1940s. Lillie retired from teaching at the Garnet Patterson Junior High School and was very active in her church."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn15",
      "id": "c02_fn15a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lillie Burke was one of the organizers of the Xi Omega Chapter in 1923, where she remained involved and dedicated until her death on December 16, 1949. She had difficulties with her eyesight in later years but was regarded as a valuable participant in chapter activities and was noted for contributing elaborate homegrown floral arrangements to brighten up events."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn16",
      "id": "c02_fn16a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("ANNA EASTER BROWN")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anna Easter Brown (1879–1957) was born on Easter Sunday in New Jersey. She graduated with honors from West Orange High School in Orange, New Jersey, and began studying at Howard University’s Teachers College Department. As one of the founding members of Alpha Kappa Alpha, she was elected its first treasurer and wrote the sorority song. While at Howard, she was known as being “solid, reliable, gentle, and sweet.” She also worked as the head night librarian, which took up most of her spare time. She, along with Lavinia Norman and Ethel Hedgeman, graduated from Howard in 1909."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn17",
      "id": "c02_fn17a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brown moved to North Carolina, where she taught for almost fifty years. First she taught at a private school in Bricks, North Carolina, where she also served as house mother and adviser to the YWCA. In 1926, she moved to the Booker T. Washington High School in Rocky Mount, North Carolina, where she taught in the Social Studies Department for thirty-one years. She worked closely with the YWCA and the American Teachers Association and was a charter member of the Chi Omega Graduate Chapter (established in 1925) in Rocky Mount."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn18",
      "id": "c02_fn18a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to her teaching and community building, Brown was highly regarded for her research in African American history. She taught her students black history, even though the conservative curriculum and school officials prohibited it. Outside of school, she traveled widely to conduct research and wrote an article published in the National Urban League’s "), _c('em', [_vm._v("Opportunity")]), _vm._v(" magazine. Her annual Negro History Exhibit always received wide acclaim, especially the 1951 exhibit, which marked her twenty-fifth anniversary in Rocky Mount; that year’s exhibit received national attention and established her reputation as a rigorous scholar of the African American experience. Brown died in March 1957 and was buried in Rocky Mount, North Carolina."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn19",
      "id": "c02_fn19a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page46"
    }
  }), _vm._v("MARJORIE HILL")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The surviving records of Marjorie Hill’s life are sparse and meager. Marjorie Hill (?–1909) began at Howard in 1904 and graduated from the School of Arts and Sciences with a bachelor’s degree in pedagogy and political science in 1908. In a reminiscence of the founders as she knew them, Margaret Flagg Holmes described Hill as a “very small, quaint, and sweet-voiced girl.” She was remembered as quiet, unassuming, and always willing to help when a job had to be done. Holmes also recalled that when faced with any significant matter, Hill would simply respond, “my mother says …,” and that would be her basis for decision making."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn20",
      "id": "c02_fn20a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In October, after graduation, she left Washington, D.C., to teach at Morgan College in Lynchburg, Virginia. Marjorie died in the summer of 1909, becoming the first “Ivy beyond the Wall.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn21",
      "id": "c02_fn21a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("MARGARET FLAGG HOLMES")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret Flagg Holmes (1886–1976) was born and raised in Greensboro, North Carolina, the daughter of the Reverend Lewis and Callie McAdoo Flagg. Although she attended elementary school in Greensboro, she went to high school in Washington, D.C. From 1904 to 1908, Margaret attended Howard on scholarship and concentrated on Latin, English, and history. She assisted Lucy Slowe in writing Alpha Kappa Alpha’s original constitution. She described herself during the founding of the organization as “tall, thin, self-conscious, interested mainly in books, but with usually a beau in the offing.” In a 1927–1928 edition of "), _c('em', [_vm._v("Ivy Leaf,")]), _vm._v(" she recorded her impressions of her fellow founders and provided an invaluable look into the personal side of the public figures who established and incorporated Alpha Kappa Alpha Sorority."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn22",
      "id": "c02_fn22a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After graduation, Margaret moved to Baltimore, where her parents were living. She began working as a substitute teacher and then taught at Baltimore High School for nine years, where Lucy Slowe was also on the faculty. She proved to be a stellar teacher: the North Central Association judged her the best Latin teacher in Baltimore. In 1917, she earned a master’s degree in philosophy from Columbia University."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn23",
      "id": "c02_fn23a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret Flagg married John Clay Holmes on August 1, 1917, and they moved to Chicago, where they were both engaged in community and activist affairs. Between 1921 and 1952, Margaret taught at Wendell Phillips High School and also at DuSable High School as head of the History Department, where she remained until she retired in 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page47"
    }
  }), _vm._v("Margaret Holmes worked closely with the YWCA and the NAACP. She associated with high-ranking NAACP leaders and scholar-activists such as W. E. B. DuBois and Joel Spingarn and suffragist Mary White Ovington. Holmes traveled nationally and internationally, and in 1931, she and her husband toured Europe for six months, where she met Pope Pius XI in Rome and entertainer Josephine Baker in Paris."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn24",
      "id": "c02_fn24a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret Flagg Holmes was a member of Theta Omega Chapter in Chicago from 1922 to 1953 and served as Anti-Basileus, Grammateus, and chapter delegate to two boulés. After retiring—right before the 1954 "), _c('em', [_vm._v("Brown v. Board of Education")]), _vm._v(" decision—she moved to New York City to live with her sister. Her husband had died in 1946, but she remained active and continued to contribute to the sorority by joining the Tau Omega Chapter in New York. In 1968, she was the guest of honor at a joint Founders’ Day celebration in New York, where Atlantic regional director Thelma Derlack Boozer celebrated her legacy. Holmes responded, “Life is for the living, to love, to share and give one’s self.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn25",
      "id": "c02_fn25a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After being of “service to all mankind” for more than sixty years, Margaret Flagg Holmes passed away on January 29, 1976, in New York."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn26",
      "id": "c02_fn26a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("26")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("LAVINIA NORMAN")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lavania Norman (1882–1983) was born in Montgomery, West Virginia, the eighth of sixteen children."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn27",
      "id": "c02_fn27a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("27")])]), _vm._v(" She entered Howard’s preparatory department in 1901. Because few women were admitted at the time, she recalled that during her junior year, she and Ethel Hedgeman were the only girls in her classes. Lavinia was central to the establishment of the sorority and worked with Margaret Flagg and Hedgeman to develop the constitution drafted by Lucy Diggs Slowe. After Hedgeman’s graduation, Norman became president of the sorority and presided over the second Ivy Day exercises. In 1909, she graduated cum laude from Howard with a bachelor’s degree in English and French and read the class history at the graduation ceremony."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn28",
      "id": "c02_fn28a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although she was recognized as an outstanding teacher and had offers to teach in numerous locations, Norman remained at Douglass High School in Huntington, West Virginia, from 1909 until her retirement in 1950. She instructed junior and senior high school students in Latin, French, English, and dramatics, as well as supervising the students’ drama productions and the Douglass High School newspaper. Norman earned an additional bachelor’s degree in 1934 from West Virginia State College."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn29",
      "id": "c02_fn29a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Norman served the Beta Tau Omega Chapter in Huntington as secretary, "), _c('a', {
    attrs: {
      "id": "page48"
    }
  }), _vm._v("speaker for Founders’ Day activities, member of the Entertainment Committee, and director of chapter plays. After retiring in 1950, she returned to Washington, D.C., and joined the Xi Omega Chapter. She suffered a slight stroke in 1978 and did not venture out in public much after that, but she celebrated her 100th birthday on December 14, 1982, with a lavish affair. She passed away one month later on January 22, 1983. Her memorial service, held in the Andrew Rankin Chapel at Howard University, was attended by Alpha Kappa Alpha women from thirty-six states, who were in Washington to participate in the sorority’s Diamond Jubilee celebration."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn30",
      "id": "c02_fn30a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("LUCY DIGGS SLOWE")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lucy Diggs Slowe (1885–1937) was born in Berryville, Virginia, the daughter of Henry Slowe, a hotel owner, and Fannie Porter Slowe. Her father died when she was only nine months old; after her mother’s death, six-year-old Lucy went to live with her aunt, Martha Slowe Price, in Lexington, Virginia. In 1904, she was the first female graduate of the Baltimore Colored High School to enroll in Howard University. She was recognized for being a gifted scholar, an outstanding singer, and a competitive tennis player, winning seventeen tennis cups."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn31",
      "id": "c02_fn31a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As one of the original group of sorority founders, she drafted the first constitution. The final document stipulated that the president have senior standing, and accordingly, Slowe was elected the first president of Alpha Kappa Alpha Sorority. Slowe graduated in 1908 and returned to Baltimore to teach English at Douglass High School for seven years. She earned a master’s degree from Columbia University in 1915. She then taught at Armstrong High School in Washington, D.C., until 1919, when the board of education requested that she head Shaw Junior High School, the first junior high school for African Americans in Washington. The school’s creed included a commitment to “the development of the highest ideals of character, wisdom, and worth … trustworthiness, dependability, regard for one’s word, deference to elders, consideration of one’s comrades, respect for oneself … and truth.” She headed Shaw until 1922, when she became the first dean of women at Howard University. However, she continued to support Shaw for almost two decades after its founding."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn32",
      "id": "c02_fn32a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the Howard "), _c('em', [_vm._v("Record,")]), _vm._v(" Slowe was “the answer to a spiritual need in the life of the women of the university.” As the number of women on campus grew, the dean of women’s position was created to handle social issues, assist "), _c('a', {
    attrs: {
      "id": "page49"
    }
  }), _vm._v("with campus policy, and provide academic guidance. Lucy Slowe held the position until her death in 1937. In an effort to improve women’s education, she also worked to develop the National Association of Women Deans, Administrators, and Counselors, and she detailed many cocurricular opportunities that Howard students should have access to."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn33",
      "id": "c02_fn33a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1923, Slowe gave a talk at the Conference of College Women held at the Phillis Wheatley YWCA in Washington, D.C. In the speech, titled “The Training of College Women,” she argued that members of organizations such as the College Alumnae Club, Association of Advisors to Women in Colored Schools, and National Federation of College Women were “charged with the responsibility of laying the foundation [and] have endeavored to lay it solidly, [so] that the superstructure—Service to humanity—may rise with confidence on a never-weakening base. Let us face the future boldly.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn34",
      "id": "c02_fn34a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Slowe stated in her 1933 article “Higher Education of the Negro Woman,” the industrial revolution, international connectedness, and women’s suffrage altered what it meant to be an educated black woman. She argued that women’s political independence garnered by suffrage in 1920 warranted an increased focus on political and economic studies. She lamented the fact that, because of lingering stereotypes, college women were limited to courses of study that prepared them for teaching or nursing; there were few opportunities for black women to gain leadership experience. Slowe’s complaint was echoed widely by black women who wrote memoirs of their college experiences."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn35",
      "id": "c02_fn35a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lucy Slowe worked with Mary McLeod Bethune to establish the National Council of Negro Women, an umbrella organization for black women’s clubs, and served as its first executive secretary. In addition to being an effective organizer, Slowe was a prolific writer. The January 1939 edition of the "), _c('em', [_vm._v("Journal of the College Alumnae Club of Washington D.C.")]), _vm._v(" included speeches she had delivered in Washington, D.C., New York, South Carolina, Georgia, and Ohio; her administrative treatises; and a 1937 national radio address challenging racial segregation in the nation’s capital."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn36",
      "id": "c02_fn36a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret Flagg Holmes remembered Lucy Slowe as “serious, hard working, conscientious, and efficient in all that she did.” Slowe died on October 21, 1937. One month before her passing, an article she wrote titled “The Colored Girl Enters College—What Shall She Expect?” was published in "), _c('em', [_vm._v("Opportunity: Journal of Negro Life.")]), _vm._v(" Slowe mused that although the college experience would be a struggle for black women, they should face the task with determination and maturity, because “students grow into well-rounded women through doing things that challenge their whole being.” Slowe embodied the type of woman she "), _c('a', {
    attrs: {
      "id": "page50"
    }
  }), _vm._v("dared other students to become. Lucy Diggs Slowe Hall at Howard University and Lucy Diggs Slowe Elementary School in Washington, D.C., were named in her honor."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn37",
      "id": "c02_fn37a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("37")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("MARIE WOOLFOLK TAYLOR")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marie Woolfolk Taylor (1893–1960) was born in Atlanta, Georgia. She attended Stoors School and was enrolled for one year at Atlanta University before entering the preparatory department of Howard University in 1904. Marie was a lyric soprano in the Howard University chorus and performed in the drama club. She was also known as a southern belle with an extensive wardrobe. She was involved in the development of the sorority from the first planning meeting and joined Ethel Hedgeman in petitioning university officials to establish the organization; she was elected its first secretary. Later, Marie was chosen to approach the seven members of the sophomore class and encourage their membership. Margaret Flagg Holmes claimed, “On special occasions, when we felt that we needed some one to uphold the dignity of the group, we selected either Lucy [Slowe] or Marie Woolfolk. Marie was the member of the chapter whose name was synonymous with clothes and such goodlooking ones … The combined wardrobe of the rest of us wouldn’t equal Marie’s at any time. And clever! She had the happy faculty of getting whatever she wanted.” In 1908, Marie graduated magna cum laude in English, with honors in Latin and history. She then moved to Cleveland, Ohio, and integrated the Schauffler Training School for Social Service, where she majored in religion. She returned to Atlanta to work with Dr. Henry Procter as the community assistant to the pastor of the First Congregational Church."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn38",
      "id": "c02_fn38a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For four years she headed the inspection department of the Standard Life Insurance Company, and in 1917, she was one of two African Americans who partnered with the Red Cross after the Atlanta fire. In 1919, she married Dr. Alfred G. Taylor of Atlanta, and they had one daughter. She remained an active member in the First Congregational Church."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn39",
      "id": "c02_fn39a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taylor assisted in the development of the Kappa Omega Chapter in 1923 and was the first chapter Basileus. She was very involved in Atlanta life; she served on the board of directors for the Carrie Steele Pitts foster home, worked on the Community Planning Council, chaired the Finance Committee of the YWCA, and was active in the Atlanta NAACP. She also worked with the Community Chest (which later became the United Way) and participated in an antituberculosis drive. She died on October 21, 1937, and her final resting place is in "), _c('a', {
    attrs: {
      "id": "page51"
    }
  }), _vm._v("Atlanta. She was survived by her daughter, Alfred Marie Taylor Anderson, also a member of Alpha Kappa Alpha Sorority."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn40",
      "id": "c02_fn40a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("40")])])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("The Sophomores of 1908")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("NORMA ELIZABETH BOYD")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Norma Boyd (1888–1985) was born in Washington, D.C., and attended school there. She entered Howard University in 1906 and graduated with a bachelor’s degree in mathematics in 1910. She was elected president of the Alpha Chapter in 1910 and was the first to serve two terms as chapter president. In 1913, she worked with Nellie Quander and Minnie Smith on the incorporation committee for the organization. According to Margaret Flagg Holmes, she was someone who could be trusted with all the “hard jobs,” because “Norma didn’t mind work in the least, so long as she could express her opinions beforehand, and she always had decided opinions, usually practical ones.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn41",
      "id": "c02_fn41a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As recorded in the 1921 inaugural edition of the "), _c('em', [_vm._v("Alpha Kappa Alpha Ivy Leaf,")]), _vm._v(" Norma Boyd served as the first Supreme Epistoleus on the first directorate and joined Nellie Quander as one of the speakers at the Third Annual Boulé held in Cleveland, Ohio, in 1920. Boyd served as Basileus of the Alpha Chapter (twice), Basileus of the Xi Omega Graduate Chapter, and North Atlantic and East Central regional director; she also chaired the first committee to raise funds for the Mississippi Health Project. Her dedication to the sorority over the years was phenomenal, and her peers lauded her as being someone for whom “no task has been too difficult, no sacrifice too big” for the work of the organization. “Miss Boyd does not know the words failure and defeat.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn42",
      "id": "c02_fn42a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Norma Boyd was regarded as an organizational genius. She chaired the first fund-raising committee for the Mississippi Health Project, which, through the dedication of Alpha Kappa Alpha members Dr. Ida Jackson and Dr. Dorothy Ferebee, made a great social impact between 1934 and 1942. Boyd also led the Xi Omega Chapter in founding and directing the National Non-Partisan Council of Public Affairs lobbying group in 1938, with a paltry budget of $135; by 1948, the civil rights organization had grown into an influential African American body with an annual budget of $25,000. Similarly, she grew an international program founded in 1945 into a significant organization that was recognized by the United Nations. For her tireless national and international activism, Boyd was honored at the 1948 inaugural awards dinner of the American Council on Human Rights in Washington, D.C.; she was honored the same year by "), _c('a', {
    attrs: {
      "id": "page52"
    }
  }), _vm._v("the National Council of Negro Women as “Woman of the Year in the Field of Legislation” for her political advocacy work. She organized the Women’s International Religious Fellowship in 1959 and, during her career, traveled in the United States, Canada, Mexico, South America, and the West Indies, working with the United Nations, nongovernmental organizations, and local human rights initiatives."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn43",
      "id": "c02_fn43a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like many of her peers, Boyd pursued higher education, taking graduate courses in education and public relations at Columbia, New York University, Berkeley, Middlebury Language School in Vermont, American University, and George Washington University. She also completed course work at the University of Mexico. Boyd taught mathematics in the Washington public schools until her retirement from Banneker Junior High School in 1948. She died in Washington on January 4, 1985—the last of the twenty Pearls to become an “Ivy beyond the Wall.” Her travels, life, and work are recorded in her autobiography, "), _c('em', [_vm._v("A Love That Equals My Labors: The Life Story of Norma E. Boyd,")]), _vm._v(" published in 1980 by Alpha Kappa Alpha Sorority."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn44",
      "id": "c02_fn44a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("44")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("ETHEL JONES MOWBRAY")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ethel Jones (?–1948) was born and educated in Baltimore, Maryland. After graduating from high school with honors, she enrolled in Howard University’s College of Arts and Sciences in 1906. She was one of the seven sophomore honor students added to the sorority and, in the first semester of 1909, was elected vice president of Alpha Kappa Alpha. On May 25, 1909, she was one of those present at the first Ivy Day celebration, during which the participants planted ivy at the south end of Miner Hall. In March 1910, during the last semester of her senior year, she became president of the sorority. Ethel graduated from Howard with a major in mathematics and a minor in education. She then returned to Baltimore to teach math in the public school system, where she stayed for two years. Her sorority sister Holmes wrote, “Ethel’s round face, rosy cheeks, and wonderful hair are the things I remember best about her, if I except her interest in Mowbray for she was wild about him.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn45",
      "id": "c02_fn45a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1913, Ethel Jones married George Mowbray and moved to Chicago. After spending the summer in Chicago, the Mowbrays moved to Kansas, where George was a teacher and Ethel was a caterer. They had two daughters. Ethel was involved during the incorporation process of the sorority and was active in expanding the program. It is recorded that she “resumed” her activity in 1924 with the establishment of the Mu Omega Chapter in Kansas City, insinuating "), _c('a', {
    attrs: {
      "id": "page53"
    }
  }), _vm._v("that there was a lapse in her activity while she pursued her culinary business. However, she continued the spirit of the sorority’s work by joining the local PTA, serving as a room mother at her daughters’ school, and supporting her husband’s career in education. Mowbray died on November 25, 1948, in Kansas City, where she was buried."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn46",
      "id": "c02_fn46a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("46")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("ALICE PORTER MURRAY")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is little information available on Alice Murray’s life. Even in Holmes’s 1928 "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" article, where she lovingly records the attributes of her founding sorors, Alice Murray is omitted. What is known is that she was born in Washington, D.C., and became a member of Alpha Kappa Alpha with the group of sophomores admitted in the spring of 1908; she was an “active participant in the early days.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn47",
      "id": "c02_fn47a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her father was P. A. Murray, and her family lived on U Street in Washington, D.C. She entered Teachers College at Howard University in 1906 and graduated with a bachelor’s degree in liberal arts and pedagogy in 1910, along the way taking classes in kindergarten teaching methods. She wrote articles on music and glee club performances that were published in the "), _c('em', [_vm._v("Howard University Journal.")]), _vm._v(" She also published short stories that, according to historian Marjorie Parker, reveal Murray as a “sensitive, cultivated person.” The date and place of Murray’s death are unconfirmed."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn48",
      "id": "c02_fn48a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("48")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("SARAH MERRIWEATHER NUTTER")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarah Merriweather (?–1950) was born in Washington, D.C., and attended public school there, graduating from the prestigious M Street High School in 1906. She graduated from Howard in 1910 with a major in English and history and earned a normal school degree in 1912. According to Holmes, Sarah was “brisk, always in more or less of a hurry, with her beautiful hair worn in a tight little knot at the back of her head [and she] could be depended upon always to see that things were right, just as they should be.” Although she gave the impression of being conservative and something of an “old maid,” Sarah was considered pleasant. In 1914, she represented Howard University at the World Student Federation Convention in Princeton, New Jersey."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn49",
      "id": "c02_fn49a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sarah taught English at Dunbar High School and then mathematics at Howard University. She married attorney T. Gillis Nutter in 1920, and they moved to Charleston, West Virginia. She was the keynote speaker at the Eighteenth "), _c('a', {
    attrs: {
      "id": "page54"
    }
  }), _vm._v("Annual Boulé (1935) in Richmond, Virginia, and was active with three chapters of Alpha Kappa Alpha in Charleston. She helped establish the Nu Chapter at West Virginia State College (1922) and Beta Beta Omega (1934), which she worked with for twenty-seven years."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn50",
      "id": "c02_fn50a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nutter organized the College Alumnae Club of Kanawha County and the Book Lover’s Club and served both through their twenty-fifth anniversaries. She also worked for the NAACP and was chairman of its Educational Committee. Like many of her cohorts, she was an avid collector of poetry, an advocate of cultural appreciation, and an activist for African American rights."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn51",
      "id": "c02_fn51a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Merriweather family was both benefactor and beneficiary of the Alpha Kappa Alpha legacy. Sarah’s father, James Merriweather, was a graduate and trustee of Howard University, and he donated the table on which the charter creating the Xi Omega Chapter was signed in the 1920s; in 1941, the cherrywood table was placed in the Founders’ Library. Sarah’s mother, Mary, eventually became a member of Alpha Kappa Alpha Sorority’s Xi Omega Chapter, signifying the family’s integral and multigenerational ties to both Howard University and Alpha Kappa Alpha Sorority. It seems fitting, then, that after Sarah Merriweather Nutter died at her home in Charleston on May 10, 1950, her body was returned to Washington, D.C., for burial."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn52",
      "id": "c02_fn52a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("52")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("JOANNA MARY BERRY SHIELDS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joanna Mary Berry (1884–1965) was born in Catherpin, Virginia, to Charles and Carrie Lucas Berry. She was the oldest of eleven children and attended private school in Prince William County. She was related to Lavinia Norman. Joanna scored 98 out of 100 on her Howard entrance examination and entered the preparatory department in 1901."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn53",
      "id": "c02_fn53a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("53")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Joanna Berry graduated cum laude from Howard University in 1910 and then taught social science for two years at Winston-Salem State Teachers College in North Carolina. She met Samuel J. Shields of Darlington, South Carolina, while visiting New York City, and they married in 1913; they had six children. After her marriage, she changed careers and became the personal secretary to Assemblyman E. A. Johnson. She resumed teaching in 1920 and held positions in South Carolina, Virginia, North Carolina, and then New York City, where she taught remedial English at Christopher Columbus High School in the Bronx from 1937 to 1943."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn54",
      "id": "c02_fn54a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shields was active in three sorority chapters: Alpha in Washington, D.C. (1909–1910), Phi Omega in North Carolina (1924–1937), and Tau Omega in "), _c('a', {
    attrs: {
      "id": "page55"
    }
  }), _vm._v("New York (1937–1958), but she served as consultant to chapters nationwide. In 1935, she attended the Eighteenth Annual Boulé in Richmond, Virginia, as a delegate of Phi Omega Chapter; there, she was honored as a founder with a diamond pin. She was also involved in the Howard University Alumni Club of New York, Upper Manhattan YWCA, NAACP, National Council of Negro Women, American Women’s Volunteer Service, Negro History Club, and Consumers Protective Committee."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn55",
      "id": "c02_fn55a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shields died on February 2, 1965, in New York City, where all her children lived. She was survived by her six children—Vivian Ida Shields, Samuel J. Shields Jr., Thomas Shields, Landrum Shields, Hanna Morgan, and Claristine Martha Brisbane—and nine grandchildren. Joanna’s daughter Claristine was a highly respected member of the Tau Omega Chapter of Alpha Kappa Alpha. Members from seven metropolitan area chapters participated in a memorial ceremony for Shields on February 4, 1965, at Williams Memorial Chapel. She was buried at the Frederick Douglass Memorial Cemetery in Staten Island."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn56",
      "id": "c02_fn56a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("56")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("CARRIE E. SNoWDEN")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Carrie Snowden (?–1948) entered the School of Arts and Sciences at Howard University in 1906. Snowden, who was remembered by Margaret Flagg Holmes as “small, slim, and gracious,” was close friends with Harriet Terry and expressed great interest in joining the sorority. Snowden was elected Epistoleus (corresponding secretary) and served beginning in the fall of 1909."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn57",
      "id": "c02_fn57a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Snowden studied English, French, German, history, geography, and science; she graduated from Howard University with a bachelor’s degree in May 1910. She was a charter member of the Xi Omega Chapter, where she served on the membership and amenities committees and was remembered by those who knew her as “shy and retiring.” Snowden embraced the concept of lifelong learning and enrolled in classes at Howard for three decades after her graduation. In addition to taking classes in commerce, economics, social work, and mathematics, she enrolled in a typing course in 1943 and worked at Howard as a switchboard operator, demonstrating students’ commitment to the institution at all levels. She died in 1948 and was buried in Washington, D.C."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn58",
      "id": "c02_fn58a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("58")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("Harriett Josephine terry")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harriet Terry (1885–1967) was born in Cornwall-on-Hudson, New York. After graduation from Cornwall-on-Hudson High School, she enrolled at Howard "), _c('a', {
    attrs: {
      "id": "page56"
    }
  }), _vm._v("University in 1906. She was recommended as one of the seven sophomore sorority members because of her “quiet charm and ever-present smile.” On October 30, 1908, she was elected treasurer, and she wrote the initiation hymn “Hail Alpha Kappa Alpha Dear,” which was sung at the first official initiation ceremony in Miner Hall on February 11, 1909. She was widely recognized for her many talents and was elected secretary of Howard’s class of 1910. She earned her bachelor’s degree in liberal arts, specializing in English, but also excelled at Latin, French, German, political science, pedagogy, history, and chemistry."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn59",
      "id": "c02_fn59a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After leaving Howard, Terry moved to Virginia, where he headed the English and history departments at Gloucester High School in Capahoasic. She then taught English at the Alabama Agricultural and Mechanical College in Normal for thirty-seven years, before retiring in 1959. She also taught extension courses for teachers in Athens and Limestone counties and, during World War I, made and inspected money at the Bureau of Engraving in the Government Printing Office in Washington, D.C. Like other sorority women, she was involved in many organizational networks, including the National Federated Women’s Club."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn60",
      "id": "c02_fn60a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was a charter member and served as Basileus of Epsilon Gamma Omega, founded in 1949 in Normal. After her retirement, Terry moved back to Washington, where she was active in Xi Omega. She passed away there on August 15, 1967. Terry Hall at Alabama A&M University was named in her honor."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn61",
      "id": "c02_fn61a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("61")])])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("The Incorporators")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("During the 1934 Founders’ Day celebration, Ethel Hedgeman Lyle honored Nellie Quander for upholding the Alpha Kappa Alpha pledge and for guarding against “treachery and faithlessness” of those who attempted to change the organization in 1912. Two of the sophomores, Norma Boyd and Ethel Mowbray (see above), joined four other members to incorporate the organization to ensure perpetuity. Though she took pride in the fact that no harsh words were exchanged during the meeting that precipitated the split by the emerging Delta Sigma Theta sorority, Quander nonetheless found it imperative to take steps toward incorporation and expansion of the original ideals, principles, and culture of Alpha Kappa Alpha Sorority. The organization was incorporated on January 29, 1913."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn62",
      "id": "c02_fn62a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("62")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page57"
    }
  }), _vm._v("JULIA EVANGELINE BROOKS")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret Holmes wrote of Julia Brooks (?–1948): She was “charming in sport-clothes long before sport clothes became the rage. How we envied Julia because she had a job and a salary. She was a public school teacher. Then, again, Julia had an ‘air’ and she was popular with the men folk, another reason for envy on our part.” Julia Brooks was born in New Orleans, Louisiana, and attended Miner Normal School to train as a teacher. After teaching elementary school, she enrolled in Howard University and graduated in 1908. Brooks was listed on the incorporation documents as the first Tamiouchus (treasurer) and served until turning the position over to Ethel Hedgeman Lyle in 1923; Lyle held the position for the next twenty years. After assisting in the incorporation, Julia Brooks remained very active in Alpha Kappa Alpha: she was a founding member of the Xi Omega Chapter in 1923 and the Anti-Basileus of the Epsilon Omega Chapter of Baltimore, Maryland. Also in 1923, she wrote “The History of Alpha Kappa Alpha Sorority,” which she presented at the boulé, the first meeting to be held in Baltimore."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn63",
      "id": "c02_fn63a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From 1916 to 1922, Brooks taught English and Spanish at Dunbar High School (formerly M Street High School), in Washington, D.C. She earned a master’s degree from Columbia University in 1928. Brooks also served as assistant principal at Dunbar High School until 1948 and was eventually appointed dean of girls. On November 24, 1948, Brooks passed away unexpectedly. In addition to her civic and social contributions, she was still very active in Xi Omega at the time."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn64",
      "id": "c02_fn64a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("64")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("NELLIE M. QUANDER")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nellie Quander (1880–1961) was born in Washington, D.C. She could trace her family roots to the Quander (Guan-do) family, which in 1984 documented 300 years of residence in Maryland and Virginia—recognized as the longest recorded African American lineage in America. Nellie’s parents were John Pierson Quander and Hanna Bruce Ford Quander. These Quanders were related to Nancy Quander, the slave that former president George Washington freed in his will. Nellie was also the granddaughter of Daniel and Hanna Bruce, prominent free blacks, and the grandniece of Blanche K. Bruce, a Mississippi senator during the Reconstruction era."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn65",
      "id": "c02_fn65a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nellie Quander attended public school in Washington, graduated with honors from Minor Normal School, and then taught at Garrison Elementary School while attending Howard University. She joined Alpha Kappa Alpha in 1911 and graduated from Howard in June 1912, majoring in history, economics, "), _c('a', {
    attrs: {
      "id": "page58"
    }
  }), _vm._v("and political science. Upon receiving notice of intended changes to the organization in October 1912, she spearheaded the incorporation process that was finalized in January 1913. After incorporation, Quander was Basileus of the first directorate. She served as national Basileus between 1913 and 1919 and remained dedicated to Alpha Kappa Alpha, setting up chapters in Illinois, Ohio, and Kansas."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn66",
      "id": "c02_fn66a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1916, Quander was commissioned by the Children’s Bureau (then under the Department of Labor) in Delaware to study economic and social conditions affecting the developmentally disabled in that state. In 1918, the Women’s War Work Council asked her to survey industrial conditions of women in Detroit."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn67",
      "id": "c02_fn67a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quander completed work for a master’s degree from Columbia University and also earned a certificate from the New York School of Social Work. She studied economics for ten summers at the University of Washington in Seattle and in 1936 was awarded a diploma from Uppsala University in Sweden. Quander taught the social sciences at Shaw Junior High School (headed by Lucy Slowe) for more than thirty years and retired in 1950. She initiated the first School Safety Patrol Unit in Washington, D.C., and remained involved in the program for twenty-five years. Quander also had a full civic life: she was on the board of directors for the Phyllis Wheatley YWCA, chairperson of the Young Women’s Department for twelve years, and YWCA special field secretary for the national office. She was active in the teachers’ union and was asked to be a representative to the Women’s Trade Union League."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn68",
      "id": "c02_fn68a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1958, commemorating the fiftieth anniversary of Alpha Kappa Alpha, she recalled that she saw “the conspicuous achievements, emphasized both in words and personal conduct of the Alpha Kappa Alpha women … moral and spiritual values, peace and friendship, scholastic attainment, courage and fortitude in remaining faithful to Alpha Kappa Alpha’s high original principles.”"), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn69",
      "id": "c02_fn69a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Nellie Quander passed away unexpectedly at her home on October 23, 1961, more than 100 sorority members attended the memorial and funeral services, including founders Beulah Burke and Lavinia Norman. Supreme Basileus Marjorie Parker read a resolution of sorrow on behalf of the 40,000 members of Alpha Kappa Alpha for the woman who had dedicated herself to the endurance of the sorority."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn70",
      "id": "c02_fn70a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("70")])])]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("NELLIE PRATT RUSSELL")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nellie Pratt (1890–1979) was born in Macon, Georgia. She entered Howard University’s College of Arts and Sciences in 1907 and became an initiate in her "), _c('a', {
    attrs: {
      "id": "page59"
    }
  }), _vm._v("second year. She was the only incorporator in the February 1909 class. Nellie graduated with a bachelor’s degree in English in 1911."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn71",
      "id": "c02_fn71a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She contributed much to the Episcopal Church Women in Virginia and was described as possessing “qualities of humanness, friendliness, and the capacity to organize and get things done.” She had “a keen sense of humor, rare brand of intelligence, and an appreciation for things aesthetic,” in addition to being a voracious reader. Her favorite authors were William Shakespeare, Rudyard Kipling, Samuel Taylor Coleridge, Omar Khayyam, Langston Hughes, and James Weldon Johnson, among others. Holmes recalled that “Nellie Pratt Russell never knew what boredom was.” In addition to reading, she kept herself busy with sewing, gardening, working crossword puzzles, and socializing, despite her arthritis. Nellie Pratt married James Alvin Russell, and they had five children who lovingly nicknamed her “Command Central” for her ability to organize, delegate, and strengthen them with a sense of purpose."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn72",
      "id": "c02_fn72a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("72")])]), _vm._v(" Nellie Pratt Russell crossed over on December 13, 1979, in Lawrenceville, Virginia.")]), _vm._v(" "), _c('h3', {
    staticClass: "section"
  }, [_vm._v("MINNIE BEATRICE SMITH")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Minnie Smith (?–1919) was a native of Washington, D.C., and graduated from Howard in 1912. In addition to being one of the incorporators, she became the first Supreme Grammateus. She was on the committee, with Norma Boyd and Nellie Quander, to pursue legal incorporation. Minnie Smith assisted in the effort toward program sustainability by writing letters to graduate members, informing them of the proposed changes to the organization and soliciting their support to maintain the origins of Alpha Kappa Alpha. Smith was present at the January 29, 1913, meeting to sign the articles of incorporation for the first national sorority of black women. Smith was close to Quander, and when Quander took a leave of absence from teaching in 1916 to pursue research in Delaware, Smith served as acting Basileus in her place. Minnie Smith died in Washington during the influenza epidemic of 1919."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn73",
      "id": "c02_fn73a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("73")])])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("Portrait of the Twenty Pearls")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Historian Marjorie Parker observed that most of the founders, sophomores, and incorporators were born in North Carolina, Washington, D.C., and Virginia, with some hailing from New York, New Jersey, Georgia, Missouri, and West Virginia. Twelve of the twenty Pearls never married. Twelve were teachers, "), _c('a', {
    attrs: {
      "id": "page60"
    }
  }), _vm._v("and others were employed in schools, churches, or social work, in addition to their homemaking and child-care responsibilities. Significantly, the twenty Pearls remained dedicated to the growth and expansion of Alpha Kappa Alpha Sorority. Parker noted that “founders were charter members of at least twelve different chapters, and four served as the first Basileus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first sororities built on the history of networking and community building established early in antebellum black communities. Accordingly, many organizations built on the solid network of sororities founded mainly at historically black colleges and universities. Lucy Slowe’s 1922 copy of the "), _c('em', [_vm._v("Howard University Student Manual")]), _vm._v(" reveals that all Howard students were expected to perform, academically and personally, in a manner that displayed “all that is best and noblest in all the outreachings of humanity.” The larger environment in which the women of Alpha Kappa Alpha developed was one of high expectation, challenge, and excellence. For the fiftieth anniversary celebration, the theme of “Pride in the Past, Gratitude for the Present, Faith in the Future—Forward to a New Era of Service” reflected the organization’s dedication to both tradition and innovation."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn74",
      "id": "c02_fn74a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although factions formed in the sorority movement, black women effectively organized and coalesced for community empowerment, but they also pushed for individual achievement. All four of the first African American women to earn PhDs were in sororities: two in Alpha Kappa Alpha (Georgiana Simpson and Anna Julia Cooper), and two in Delta Sigma Theta (Sadie T. M. Alexander and Eva Dykes). The twenty Pearls of Alpha Kappa Alpha began an organization that subsequently counted many well-known women among its members, including educators such as Charlotte Hawkins Brown; scholars such as Maya Angelou, Toni Morrison, and Mae Jamison; and entertainers Ella Fitzgerald and Alicia Keys."), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn75",
      "id": "c02_fn75a"
    }
  }, [_c('sup', {
    staticClass: "frac"
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the eve of its 100th anniversary, Alpha Kappa Alpha Sorority boasts more than 170,000 members in 930 chapters. Much work “in service to all mankind” has been done in the memory of the original founders; much work remains to be done. By gaining a clearer picture of the founders’ lives, members can reflect on current practices to ensure that they are in line with original goals. But these stories are valuable for scholarly research as well. Interest in research on black Greek-letter organizations is essential to a better understanding of organizational, African American, and educational history. These women’s personal histories illuminate the gendered, social, cultural, economic, and political dimensions of the United States during a crucial point in the development of the Jim Crow and civil rights eras. By closely investigating founders’ lives, we may increase historical understanding beyond organizations and construct "), _c('a', {
    attrs: {
      "id": "page61"
    }
  }), _vm._v("useful portraits of African Americans in history that honor the complexity of their lives, community service, cultural mores, and social justice movements. Contemporary visions of merit, culture, and service will be clearer when focused on these virtuous women.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The author would like to thank the excellent staff at the Moorland-Spingarn Research Center (especially Jo Ellen Bashir) for access to its collections and for assistance with archival research. I also thank Soror Yvonne Rawls of the Mu Upsilon Omega Chapter of Alpha Kappa Alpha (Gainesville, Florida) for sharing rare primary resources from her personal collection and Soror Gloria Dickinson in New Jersey for her invaluable research.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn1"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn1a"
    }
  }, [_vm._v("1.")]), _vm._v(" André McKenzie, “In the Beginning: The Early History of the Divine Nine,” in "), _c('em', [_vm._v("African American Fraternities and Sororities: The Legacy and the Vision,")]), _vm._v(" ed. Tamara L. Brown, Gregory S. Parks, and Clarenda M. Phillips (Lexington: University Press of Kentucky, 2005), 184–86; Marjorie H. Parker, "), _c('em', [_vm._v("Past Is Prologue: The History of Alpha Kappa Alpha, 1908–1999")]), _vm._v(" (Washington, D.C.: Alpha Kappa Alpha Sorority, 1999), 3–4, 21. Note that Lawrence C. Ross, in "), _c('em', [_vm._v("The Divine Nine")]), _vm._v(" (New York: Kensington Publishing, 2000), mistakenly lists Hedgeman’s adviser’s name as Ethel Aremain Robinson.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn2"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn2a"
    }
  }, [_vm._v("2.")]), _vm._v(" McKenzie, “In the Beginning,” 184–86; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 3–4, 21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn3"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn3a"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1948): 33; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (1958): 5; Marjorie H. Parker, "), _c('em', [_vm._v("Alpha Kappa Alpha: Sixty Years of Service")]), _vm._v(" (Washington, D.C.: Alpha Kappa Alpha Sorority, 1966), 7; Marjorie H. Parker, "), _c('em', [_vm._v("Alpha Kappa Alpha through the Years, 1908–1988")]), _vm._v(" (Chicago: Mobium Press, 1990), 15; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 7–8; Paula Giddings, "), _c('em', [_vm._v("In Search of Sisterhood: Delta Sigma Theta and the Challenge of the Black Sorority Movement")]), _vm._v(" (New York: William Morrow, 1988), 44; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 179–80; Ernestine Green McNealey, “Lyle,” in "), _c('em', [_vm._v("Black Women in America: Historical Encyclopedia,")]), _vm._v(" ed. Darlene Clark Hine, Elsa Barkley Brown, and Rosalyn Terbourg-Penn (Bloomington: Indiana University Press, 1994), 737. Ernestine Green McNealey, "), _c('em', [_vm._v("Pearls of Service: The Legacy of America’s First Black Sorority, Alpha Kappa Alpha")]), _vm._v(" (Chicago: Alpha Kappa Alpha Sorority, 2006), and "), _c('em', [_vm._v("Black Women in America")]), _vm._v(" list Lyle’s birth year as 1887, but the "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" sources cite 1885 as the correct date.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn4"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn4a"
    }
  }, [_vm._v("4.")]), _vm._v(" Ross, The Divine Nine, 180.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn5"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn5a"
    }
  }, [_vm._v("5.")]), _vm._v(" Parker, Through the Years, 15; Ross, The Divine Nine, 180.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn6"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn6a"
    }
  }, [_vm._v("6.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 7; McKenzie, “In the Beginning,” 184; Giddings, "), _c('em', [_vm._v("In Search of Sisterhood,")]), _vm._v(" 44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn7"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn7a"
    }
  }, [_vm._v("7.")]), _vm._v(" Parker, Through the Years, 15; Ross, The Divine Nine, 180.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn8"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn8a"
    }
  }, [_vm._v("8.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (March 1951): 5; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page62"
    }
  }), _vm._v("15; McKenzie, “In the Beginning,” 184. Margaret Flagg Holmes accounts for many of the original members of Alpha Kappa Alpha in "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" 6, no. 4 (November 1928): 37–38, reprinted as “Our Founders in Retrospect—by One of Them,” "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" 52, no. 2 (summer 1976): 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn9"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn9a"
    }
  }, [_vm._v("9.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (March 1951): 5; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 15; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 180.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn10a"
    }
  }, [_vm._v("10.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (1927): 1; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (March 1951): 5; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 15; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 180.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn11a"
    }
  }, [_vm._v("11.")]), _vm._v(" Ivy Leaf (May 1928): 49; Parker, Through the Years, 15; Ross, The Divine Nine, 181.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn12"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn12a"
    }
  }, [_vm._v("12.")]), _vm._v(" Although some sources cite 1883 as her birth date, the 1880 census confirms the date as 1885. "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1975): 40; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (fall 1975): 36; Parker, "), _c('em', [_vm._v("Sixty Years of Service,")]), _vm._v(" 8; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 17; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 181. In Margaret Holmes’s 1920s reflection on the founders, she lists Beulah’s last name as Gowens. "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn13"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn13a"
    }
  }, [_vm._v("13.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1975): 40; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (fall 1975): 36; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 17; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 181. The 1958 "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" incorrectly lists the Gamma founding date as 1914; the correct date is given in "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 295.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn14"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn14a"
    }
  }, [_vm._v("14.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (fall 1975): 36; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 182; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 17–18; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 181. The sources disagree on the actual date of her passing: Parker and Ross both cite April 8, but the fall 1975 "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" lists April 28, 1975. I cite April 28 because the 1975 primary source gives much more detail and is probably more accurate. It is possible, however, that the 28 is a typographical error.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn15"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn15a"
    }
  }, [_vm._v("15.")]), _vm._v(" Parker, Past Is Prologue, 7; Parker, Sixty Years of Service, 8; Parker, Through the Years, 18–19; Ross, The Divine Nine, 186–87.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn16"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn16a"
    }
  }, [_vm._v("16.")]), _vm._v(" Parker, Through the Years, 18–19; Ross, The Divine Nine, 187.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn17"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn17a"
    }
  }, [_vm._v("17.")]), _vm._v(" Parker, Through the Years, 15; Ross, The Divine Nine, 184.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn18"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn18a"
    }
  }, [_vm._v("18.")]), _vm._v(" Parker, Through the Years, 15; Ross, The Divine Nine, 185.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn19"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn19a"
    }
  }, [_vm._v("19.")]), _vm._v(" Ibid.; McNealey, "), _c('em', [_vm._v("Pearls of Service,")]), _vm._v(" 30–31.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn20"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn20a"
    }
  }, [_vm._v("20.")]), _vm._v(" Ivy Leaf (summer 1976): 4; Parker, Sixty Years of Service, 7; Parker, Through the Years, 13; Ross, The Divine Nine, 179.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn21"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn21a"
    }
  }, [_vm._v("21.")]), _vm._v(" Parker, Through the Years, 13; Ross, The Divine Nine, 179.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn22"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn22a"
    }
  }, [_vm._v("22.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1976): 36; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Sixty Years of Service,")]), _vm._v(" 8; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 18; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 185. Here again, the sources disagree on the details. The 1958 "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" and Ross both list her majors as Latin, English, and history; Parker lists English and Latin; and the 1976 "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" claims that she majored in Spanish and Latin.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn23"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn23a"
    }
  }, [_vm._v("23.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1976): 36; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 18; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 185. Parker and Ross say that her degree was in philosophy, but the "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" says social science.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn24"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn24a"
    }
  }, [_vm._v("24.")]), _vm._v(" Parker, Through the Years, 18; Ross, The Divine Nine, 186.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn25"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn25a"
    }
  }, [_vm._v("25.")]), _vm._v(" Parker, Through the Years, 18; Ivy Leaf (June 1958): 6; Ross, The Divine Nine, 186.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn26"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn26a"
    }
  }, [_vm._v("26.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page63"
    }
  }), _vm._v("Parker, Through the Years, 18; Ross, The Divine Nine, 186.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn27"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn27a"
    }
  }, [_vm._v("27.")]), _vm._v(" Parker, Through the Years, 18; Ross, The Divine Nine, 189.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn28"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn28a"
    }
  }, [_vm._v("28.")]), _vm._v(" Ivy Leaf (June 1958): 6; Parker, Through the Years, 18; Ross, The Divine Nine, 189.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn29"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn29a"
    }
  }, [_vm._v("29.")]), _vm._v(" Parker, Through the Years, 19; Ross, The Divine Nine, 189.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn30"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn30a"
    }
  }, [_vm._v("30.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 7; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 19; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 189–90.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn31"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn31a"
    }
  }, [_vm._v("31.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 13; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 182; Linda Perkins, “Slowe, Lucy Diggs,” "), _c('em', [_vm._v("American National Biography Online,")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "http://www.anb.org",
      "target": "_blank"
    }
  }, [_vm._v("http://www.anb.org")]), _vm._v(" (accessed November 16, 2007); Kathleen Thompson, “Slowe, Lucy” in "), _c('em', [_vm._v("Black Women in America,")]), _vm._v(" 1071–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn32"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn32a"
    }
  }, [_vm._v("32.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 13; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 183; Lucy Slowe, “My Creed for Life,” "), _c('em', [_vm._v("Journal of the College Alumnae Club of Washington D.C.,")]), _vm._v(" memorial edition (January 1939): 34–35, Lucy Slowe Papers, Moorland-Spingarn Research Center.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn33"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn33a"
    }
  }, [_vm._v("33.")]), _vm._v(" Elizabeth Ihle, "), _c('em', [_vm._v("Black Women in Higher Education: An Anthology of Essays, Studies, and Documents")]), _vm._v(" (New York: Garland, 1992), xxviii; Lucy Slowe, “Higher Education of the Negro Woman,” "), _c('em', [_vm._v("Journal of Negro Education")]), _vm._v(" (July 1933): 352–58; Lucy Slowe, “Colored Girl Enters College—What Shall She Expect?” "), _c('em', [_vm._v("Opportunity: Journal of Negro Life")]), _vm._v(" (September 1937): 276–79; Slowe, “My Creed for Life,” 34–35; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 13; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 183.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn34"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn34a"
    }
  }, [_vm._v("34.")]), _vm._v(" Association of College Women, "), _c('em', [_vm._v("Proceedings of the Conference of College Women, April 6 and 7, 1923,")]), _vm._v(" 28, Lucy Diggs Slowe Collection, Moorland-Spingarn Research Center.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn35"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn35a"
    }
  }, [_vm._v("35.")]), _vm._v(" Deborah Gray White, "), _c('em', [_vm._v("Too Heavy a Load: Black Women in Defense of Themselves, 1894–1994")]), _vm._v(" (New York: W. W. Norton, 1999), 40–41; Ihle, "), _c('em', [_vm._v("Black Women in Higher Education,")]), _vm._v(" 189–90; Slowe, “Higher Education of the Negro Woman,” 354, 356; Mary Church Terrell, "), _c('em', [_vm._v("A Colored Woman in a White World")]), _vm._v(" (1940; reprint, New York: Arno Press, 1980), 52–53. For examples of memoirs, see “Reminiscences of School Life: Six College Memoirs,” in Stephanie Y. Evans, "), _c('em', [_vm._v("Black Women in the Ivory Tower, 1850–1954: An Intellectual History")]), _vm._v(" (Gainesville: University Press of Florida, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn36"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn36a"
    }
  }, [_vm._v("36.")]), _vm._v(" College Alumnae Club, Journal of the College Alumnae Club of Washington D.C. (January 1939); Ihle, Black Women in Higher Education, 185; Anna Julia Cooper, “Higher Education of Women,” in The Voice of Anna Julia Cooper: Including A Voice from the South and Other Important Essays, Papers, and Letters (Lanham, Md.: Rowman and Littlefield, 1998), 84; Linda Perkins, “Education,” in Black Women in America, 386–87.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn37"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn37a"
    }
  }, [_vm._v("37.")]), _vm._v(" Slowe, “Colored Girl Enters College,” 279; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Thompson, “Slowe,” in "), _c('em', [_vm._v("Black Women in America,")]), _vm._v(" 1071–72. In her encyclopedia entry, Thompson incorrectly lists Slowe’s date of death as 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn38"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn38a"
    }
  }, [_vm._v("38.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 16; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 187–88. In the "), _c('em', [_vm._v("Ivy Leaf,")]), _vm._v(" Holmes refers to Marie Woolfolk’s last name as “Young”; there "), _c('a', {
    attrs: {
      "id": "page64"
    }
  }), _vm._v("is no evidence of her marrying a Young, so the name could be an error on Holmes’s part.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn39"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn39a"
    }
  }, [_vm._v("39.")]), _vm._v(" Parker, Through the Years, 16; Ross, The Divine Nine, 188.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn40"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn40a"
    }
  }, [_vm._v("40.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 16.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn41"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn41a"
    }
  }, [_vm._v("41.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 5; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 15–16; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 18, 25; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 190.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn42"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn42a"
    }
  }, [_vm._v("42.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (1921): 6–7, 13; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (1927): 1; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6–7; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 5; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 190.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn43"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn43a"
    }
  }, [_vm._v("43.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (March 1940): 9; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1948): 37; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 5; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 16–17; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 25–26; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 191; Robert L. Harris Jr., “Lobbying Congress for Civil Rights: The American Council on Human Rights, 1948–1963,” in "), _c('em', [_vm._v("African American Fraternities and Sororities,")]), _vm._v(" 214.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn44"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn44a"
    }
  }, [_vm._v("44.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 5; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 25; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 16; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 190–91. "), _c('em', [_vm._v("Pearls of Service")]), _vm._v(" (49) states that Boyd passed away in New York City.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn45"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn45a"
    }
  }, [_vm._v("45.")]), _vm._v(" Ivy Leaf (summer 1976): 4; Parker, Through the Years, 22; Parker, Past Is Prologue, 12–13; Ross, The Divine Nine, 191.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn46"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn46a"
    }
  }, [_vm._v("46.")]), _vm._v(" Parker, Through the Years, 22; Parker, Past Is Prologue, 12–13; Ross, The Divine Nine, 191.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn47"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn47a"
    }
  }, [_vm._v("47.")]), _vm._v(" Parker, Through the Years, 21; Parker, Past Is Prologue, 12; Ross, The Divine Nine, 194.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn48"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn48a"
    }
  }, [_vm._v("48.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn49"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn49a"
    }
  }, [_vm._v("49.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1935): 5; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1950): 55–56; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 13. Holmes spelled her sorority sister’s name “Sara Merriwether.” While at the Princeton conference, Merriweather sent Nellie Quander a piece of ivy from former president Grover Cleveland’s grave site; the leaf was planted near the Manual Arts Building at Howard University.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn50"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn50a"
    }
  }, [_vm._v("50.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1935): 5; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1950): 55–56; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; McNealey, "), _c('em', [_vm._v("Pearls of Service,")]), _vm._v(" 53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn51"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn51a"
    }
  }, [_vm._v("51.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (September–December 1950): 55; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 13–14; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 195–96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn52"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn52a"
    }
  }, [_vm._v("52.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1950): 46; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (September–December 1950): 55; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 22–23; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 13–14; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 195–96. The June "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" lists her date of death as May 8; the date given in the September–December 1950 issue is probably more accurate because it provides explicit details of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn53"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn53a"
    }
  }, [_vm._v("53.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (February–March 1965): 40; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 7; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 192.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn54"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn54a"
    }
  }, [_vm._v("54.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (February–March 1965): 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn55"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn55a"
    }
  }, [_vm._v("55.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (February–March 1965): 40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn56"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn56a"
    }
  }, [_vm._v("56.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page65"
    }
  }), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (February–March 1965): 40; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 7; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 15; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 193. Claristine attended Winston-Salem State Teachers College, earned a bachelor’s degree from Columbia University, and worked as a librarian and public servant in New York until her death in 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn57"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn57a"
    }
  }, [_vm._v("57.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 21–22; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 12–13; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 197.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn58"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn58a"
    }
  }, [_vm._v("58.")]), _vm._v(" Ivy Leaf (June 1958): 9; Parker, Past Is Prologue, 12–13; Ross, The Divine Nine, 197.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn59"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn59a"
    }
  }, [_vm._v("59.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 15; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 196. The 1958 "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" incorrectly lists her graduation date as 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn60"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn60a"
    }
  }, [_vm._v("60.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 6; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (September 1967): 46; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 196.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn61"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn61a"
    }
  }, [_vm._v("61.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn62"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn62a"
    }
  }, [_vm._v("62.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1948): 32; Parker, "), _c('em', [_vm._v("Through the Years,")]), _vm._v(" 254; McKenzie, “In the Beginning,” 185–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn63"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn63a"
    }
  }, [_vm._v("63.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (summer 1976): 4; Parker, "), _c('em', [_vm._v("Past Is Prologue,")]), _vm._v(" 18, 24, 67; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 198–99.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn64"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn64a"
    }
  }, [_vm._v("64.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn65"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn65a"
    }
  }, [_vm._v("65.")]), _vm._v(" Parker, Through the Years, 41–43; Parker, Past Is Prologue, 72–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn66"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn66a"
    }
  }, [_vm._v("66.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 7; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1961): 2; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 197.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn67"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn67a"
    }
  }, [_vm._v("67.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (1921): 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn68"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn68a"
    }
  }, [_vm._v("68.")]), _vm._v(" Ibid.; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 7; "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (December 1961): 2; Ross, "), _c('em', [_vm._v("The Divine Nine,")]), _vm._v(" 197–98.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn69"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn69a"
    }
  }, [_vm._v("69.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 7, 24.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn70"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn70a"
    }
  }, [_vm._v("70.")]), _vm._v(" Ivy Leaf (December 1961): 32; Ross, The Divine Nine, 197; Giddings, In Search of Sisterhood, 50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn71"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn71a"
    }
  }, [_vm._v("71.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (spring 1980): 6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn72"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn72a"
    }
  }, [_vm._v("72.")]), _vm._v(" Ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn73"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn73a"
    }
  }, [_vm._v("73.")]), _vm._v(" "), _c('em', [_vm._v("Ivy Leaf")]), _vm._v(" (June 1958): 9.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn74"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn74a"
    }
  }, [_vm._v("74.")]), _vm._v(" "), _c('em', [_vm._v("Howard University Student Manual,")]), _vm._v(" July 1922, 3, Lucy Diggs Slowe Collection, Moorland-Spingarn Research Center; Parker, "), _c('em', [_vm._v("Sixty Years of Service,")]), _vm._v(" vii.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "c02_fn75"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/#c02_fn75a"
    }
  }, [_vm._v("75.")]), _vm._v(" Linda Perkins, “Black Feminism and ‘Race Uplift,’ 1890–1900” (Radcliffe Institute working paper, Mary Ingraham Bunting Institute, Cambridge, Mass., 1981); Linda Perkins, “Black Women and the Philosophy of ‘Racial Uplift’ prior to Emancipation” (Radcliffe Institute working paper, Mary Ingraham Bunting Institute, Cambridge, Mass., 1980); Francille Wilson, “‘All of the Glory … Faded … Quickly’: Sadie T. M. Alexander and Black Professional Women, 1920–50,” in "), _c('em', [_vm._v("Sister Circle: Black Women and Work,")]), _vm._v(" ed. Sharon Harley (New Brunswick, N.J.: Rutgers University Press, 2002), 164–83; Catherine Johnson, “Georgiana Simpson,” in "), _c('em', [_vm._v("Black Women in America,")]), _vm._v(" 1038–39.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ca169a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780813172958_epub_c02_r1.vue
// module id = 90
// module chunks = 0